import * as yup from "yup";
export const customizeValidationSchema = () => {
  let customSchema = yup.object().shape({
    paymentDate: yup.date().required("Payment date is required"),
  });

  return customSchema;
};
